export const notificationConstants = {
    NOTIFICATION_TYPE_MESSAGE: 'NOTIFICATION_TYPE_MESSAGE',
    EXCLUDE_NOTIFICATION: 'EXCLUDE_NOTIFICATION',
    ON_TIMEOUT: 'ON_TIMEOUT'
};
